import { findIndex } from 'lodash'

export default class Checkpoint {
  constructor(checkpoint = {}) {
    this.id = checkpoint.id || null
    this.value = checkpoint.value || ''
    this.cwe_id = checkpoint.cwe_id || ''
    this.risk_level = checkpoint.risk_level || ''
    this.corrective_measures = checkpoint.corrective_measures || ''
    this.cwe = checkpoint.cwe || {}
    this.sections = checkpoint.sections || []
    this.assessor = checkpoint.assessor || {}
  }

  static mutations() {
    return {
      setCheckpoint: (state, checkpoint) => state.checkpoint = new Checkpoint(checkpoint),
      updateValue: (state, payload) => state.checkpoint.value = payload,
      updateRiskLevel: (state, payload) => state.checkpoint.risk_level = payload,
      updateCwe: (state, payload) => state.checkpoint.cwe_id = payload,
      updateCorrectiveMeasures: (state, payload) => state.checkpoint.corrective_measures = payload,
      updateSectionSecureSetting: (state, payload) => {
        let index = findIndex(state.checkpoint.sections, section => section.id === payload.sectionId)
        let section = state.checkpoint.sections[index]
        section.setting.secure_setting = payload.value
        state.checkpoint.sections.splice(index, 1, section)
      },
      clearAssessor: (state) => state.checkpoint.assessor = {},
      setAssessor: (state, payload) => state.checkpoint.assessor = payload,
      removeSection: (state, payload) => {
        let index = state.checkpoint.sections.indexOf(payload)
        state.checkpoint.sections.splice(index, 1)
      }
    }
  }
}